/**
 * Typed accessor for the `VITE_PUBLIC_*` environment variables baked into
 * the browser bundle at build time. All values are PUBLIC — they are visible
 * to anyone who loads the site. No secrets here.
 *
 * See `.env.example` / wrangler.toml `[vars]` for the canonical list.
 */
export interface PublicEnv {
  apiBase: string;
  appDomain: string;
  solanaCluster: string;
  solanaRpcUrl: string;
  walletConnectProjectId: string;
}

function readEnv(): PublicEnv {
  const env = import.meta.env;
  return {
    apiBase: env.VITE_PUBLIC_API_BASE ?? 'https://api.solana.avcd.io',
    appDomain: env.VITE_PUBLIC_APP_DOMAIN ?? 'solana.avcd.io',
    solanaCluster: env.VITE_PUBLIC_SOLANA_CLUSTER ?? 'mainnet-beta',
    // CORS-friendly public mainnet RPC. Override per-environment via
    // wrangler.toml `vars.VITE_PUBLIC_SOLANA_RPC_URL` to point at a paid /
    // private endpoint when traffic outgrows the free tier.
    // NB: do NOT use https://api.mainnet-beta.solana.com — it 403s on many
    // Squads SDK calls (getMultipleAccounts / getProgramAccounts).
    solanaRpcUrl: env.VITE_PUBLIC_SOLANA_RPC_URL ?? 'https://solana-rpc.publicnode.com',
    walletConnectProjectId: env.VITE_PUBLIC_WALLETCONNECT_PROJECT_ID ?? '',
  };
}

export const env: PublicEnv = readEnv();
